import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, StickyNote } from "lucide-react";
import NotesPanel from "../components/NotesPanel";
import BottomNav from "../components/BottomNav";
import { useNotes } from "../lib/notes-context";

/**
 * Página /notas — experiência "estilo app" no mobile (acessível pela BottomNav)
 * e grid de cards no desktop.
 */
export default function NotesPage() {
    const navigate = useNavigate();
    const { notes } = useNotes();

    return (
        <div className="h-[100dvh] bg-background flex flex-col overflow-hidden">
            <header className="shrink-0 z-30 h-12 md:h-14 border-b border-border bg-[#0A0A0A]/95 backdrop-blur-xl flex items-center gap-2 px-3 sm:px-6" data-testid="notes-header">
                <button
                    type="button"
                    onClick={() => navigate("/chat")}
                    className="p-2 -ml-2 rounded-sm text-muted-foreground hover:text-foreground hover:bg-muted transition-colors"
                    aria-label="Voltar ao chat"
                    data-testid="notes-back"
                >
                    <ArrowLeft className="w-5 h-5" />
                </button>
                <StickyNote className="w-4 h-4 text-primary" />
                <h1 className="font-display font-bold tracking-tight text-sm md:text-base">Bloco de Notas</h1>
                {notes.length > 0 && (
                    <span className="text-[10px] font-mono text-muted-foreground bg-muted rounded-full px-2 py-0.5">{notes.length}</span>
                )}
            </header>

            <main className="flex-1 overflow-y-auto w-full">
                <div className="max-w-5xl mx-auto px-4 sm:px-6 py-4 md:py-6 pb-24 md:pb-8">
                    <NotesPanel variant="page" />
                </div>
            </main>

            <BottomNav />
        </div>
    );
}
